/** What an open cycle is waiting for, in one line a reader can act on. */
import type { CycleOutlookResponse } from "@/shared/api";
import { signedPercent } from "@/shared/money/money";

function day(iso: string): string {
  const at = new Date(iso);
  const dd = String(at.getUTCDate()).padStart(2, "0");
  const mm = String(at.getUTCMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}`;
}

function hour(iso: string): string {
  const at = new Date(iso);
  return `${String(at.getUTCHours()).padStart(2, "0")}:${String(at.getUTCMinutes()).padStart(2, "0")}`;
}

/**
 * «до цели +10,5% · докупка −6,4%», «трейлинг продаст по 1.12»,
 * «до цели +38% · сетка куплена, докупка на развороте с 04.11».
 */
export function outlookText(
  outlook: CycleOutlookResponse | null | undefined,
  now: Date,
  format: (price: string) => string = (price) => price,
): string | null {
  if (outlook == null) return null;
  if (outlook.delisting_close_at != null) {
    const target = outlook.to_target == null ? null : `до выхода ${signedPercent(outlook.to_target, 1)}`;
    return [target, `иначе закроется ${day(outlook.delisting_close_at)} ${hour(outlook.delisting_close_at)} UTC`]
      .filter((part) => part !== null)
      .join(" · ");
  }
  if (outlook.trailing_sell_price != null) return `трейлинг продаст по ${format(outlook.trailing_sell_price)}`;
  const parts: string[] = [];
  if (outlook.to_target != null) parts.push(`до цели ${signedPercent(outlook.to_target, 1)}`);
  if (outlook.to_next_rung != null) parts.push(`докупка ${signedPercent(outlook.to_next_rung, 1)}`);
  if (outlook.ladder_spent && outlook.recovery_from != null) {
    parts.push(
      Date.parse(outlook.recovery_from) <= now.getTime()
        ? "сетка куплена, докупка на развороте"
        : `сетка куплена, докупка на развороте с ${day(outlook.recovery_from)}`,
    );
  }
  return parts.length === 0 ? null : parts.join(" · ");
}
